<template>
	<div>
		<Ubicacion :pWidth="'1130px'" :Arreglo="[]" :rutaempresa="'/'" :rutasucursal="'/'"></Ubicacion>
	</div>
</template>

<script>
import Ubicacion from "./Ubicacion.vue";
export default {
	name:'Geolocalizacion',
	components:{Ubicacion},
	mounted() {
		this.bus.$emit("SetUbicaciones");
	},
}
</script>

<style>

</style>
